import { computed } from '@angular/core';
import { patchState, signalStore, withComputed, withMethods, withState } from '@ngrx/signals';


type State = {
    halfWindows: Record<string, boolean>;
    openedWindow: string | null;
};


export const halfWindow = (halfWindows: Record<string, boolean>, name: string | null) =>
    name !== null && (typeof halfWindows[name] === 'undefined' ? true : halfWindows[name]);


export const WindowStore = signalStore(
    { providedIn: 'root' },

    withState<State>({
        halfWindows: {},
        openedWindow: null,
    }),

    withMethods(state => ({
        openWindow(name: string) {
            patchState(state, { openedWindow: name });
        },

        closeWindow() {
            patchState(state, { openedWindow: null });
        },

        expandWindow(expand?: boolean) {
            const openedWindow = state.openedWindow();
            const halfWindows = state.halfWindows();
            if (openedWindow === null) {
                return;
            }
            if (typeof expand === 'undefined') {
                expand = halfWindow(halfWindows, openedWindow);
            }
            if (halfWindow(halfWindows, openedWindow) !== !expand) {
                patchState(state, { halfWindows: { ...halfWindows, [openedWindow]: !expand } });
            }
        }
    })),

    withComputed(({ halfWindows, openedWindow }) => ({
        halfWindow: computed(() => halfWindow(halfWindows(), openedWindow())),
    })),
);
